import { Typography, styled, useTheme } from "@mui/material"
import { StrikeThroughChip } from "@pharmupp/p3-front-commons"
import { Check } from "react-feather"

interface CPStatusChipProps {
  isActive: boolean
}

export const CPStatusChip = ({ isActive }: CPStatusChipProps) => {
  const theme = useTheme()
  if (isActive) {
    return (
      <FilledChip
        color="#fff"
        label={
          <>
            <Check size={16} />
            <Typography component="span">CSE</Typography>
          </>
        }
        size="small"
      />
    )
  }
  return (
    <StrikeThroughChip
      color={theme.palette.grey.light}
      label="CSE"
      size="small"
      isStrikethrough
    />
  )
}

const FilledChip = styled(StrikeThroughChip)(({ theme }) => ({
  background: theme.palette.success.main,
  padding: "0 8px",
}))
